import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { AdminGuard } from './shared/guards/admin.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./features/home/home.module').then(
        (m) => m.HomeModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./features/dashboard/dashboard.module').then(
        (m) => m.DashboardModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'writeback-history',
    loadChildren: () =>
      import('./modules/writeback-manager/writeback-manager.module').then(
        (m) => m.WritebackManagerModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dev-panel',
    loadChildren: () =>
      import('./features/dev-panel/dev-panel.module').then(
        (m) => m.DevPanelModule,
      ),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./features/settings/settings.module').then(
        (m) => m.SettingsModule,
      ),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'projects',
    loadChildren: () => import('./modules/projects-summaries/projects-summaries.module').then(m => m.ProjectsSummariesModule)
  },
  {
    path: 'executive-orders',
    loadChildren: () => import('./modules/executive-orders/executive-order.module').then(m => m.ExecutiveOrdersModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
